import { IEditableServerSettings } from '../types/IEditableServerSettings';
import { Request } from './Request';

export interface IGetServerSettingsParams {
}

export interface IGetServerSettingsResult {
  serverSettings: IEditableServerSettings;
}

export class GetServerSettingsRequest extends Request<IGetServerSettingsParams, IGetServerSettingsResult> {
  constructor(params: IGetServerSettingsParams) {
    super('getServerSettings', params);
  }
}
